'use strict';

$(function(){

	var $addReviewContainer = $('.js-add-resource-review');

	//Check if add review form exists, only than do stuff
	if($addReviewContainer.length === 0) return;

	window.TES = window.TES || {};

	var resourceAuthor = window.TES.resource && window.TES.resource.authorId.toString();
	var user = window.TES.user;
	var userId = user.getId() && user.getId().toString();
	var currentUserIsAuthor = function() {
		return user.isAuthenticated() && userId === resourceAuthor;
	};

	//Check if user is not author and logged in than show the form, else return
	if(!currentUserIsAuthor()) {
		$addReviewContainer.show();
	}
	else {
		return;
	}

	var $addReviewBtn = $('.js-review-addBtn');
	var $reviewsListContainer = $('.js-reviews-list');
	var $rating = $('.js-review-rating');
	var $comment = $('.js-review-comment');
	var $ratingError = $('.js-rating-error');
	var $commentError = $('.js-comment-error');
	var $commonError = $('.js-review-error');
	var $commonSuccess = $('.js-review-success');
	var isValidRating = function() {
		return $rating.val() !== '0';
	};
	var isValidComment = function() {
		return $comment.val().trim().length !== 0;
	};
	var isAnyError = function() {
		return !isValidRating() || !isValidComment();
	};
	var hideCommonMessages = function() {
		$commonError.add($commonSuccess).slideUp();
	};
	var resetForm = function() {
		$rating.val(0);
		$comment.val('');
		$addReviewBtn.prop('disabled', false);
	};
	var success = function(response) {
		$reviewsListContainer.replaceWith(response);
		//update the refrence
		$reviewsListContainer = $('.js-reviews-list');
		$commonSuccess.show();
		//hide message after sometime and reset the form
		setTimeout(function(){
			hideCommonMessages();
			resetForm();
		}, 4000);
	};

	//Toggle rating error when user select valid option
	$rating.on('change', function(){
		$ratingError.toggle( !isValidRating() );
		hideCommonMessages();
	});

	//Toggle comment error when user types
	$comment.on('keyup', function(){
		$commentError.toggle( !isValidComment() );
		hideCommonMessages();
	});

	//Click event
	$addReviewBtn.on('click',function(e){
		
		e.preventDefault();

		if(isAnyError()) {
			$rating.change();
			$comment.keyup();
			return;
		}
		else {

			//Hide common error or success messages
			hideCommonMessages();

			var data = {
				rating: $rating.val(),
		comment: $comment.val(),
				asset: {
					id: $('.js-resource-id').val(),
					type: 'resources',
			authorId: $('.js-author-id').val()
				},
				template: $('.js-reviews-list-template').val()
			};

			//console.log(data);
			
			//Ajax to add review
			$.ajax({
				type: 'POST',
				dataType: 'html',
				contentType: 'application/json; charset=utf-8',
				url: '/api/review',
				data: JSON.stringify(data),
				beforeSend: function() {
					$addReviewBtn.prop('disabled', true);
				},
				success: success,
				error: function(){ $commonError.show(); }
			});
		}
	});
});
